import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import About from './pages/About.vue'
import Compilation from './components/Compilation.vue'
import 'leaflet/dist/leaflet.css'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Flowers That Bloom At Midnight ',
    component: Compilation,
    props: true
  },
  {
    path: '/compilation',
    name: 'Flowers That Bloom At Midnight',
    component: Compilation,
    props: true
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    props: false,
  },
]

const router = new VueRouter({
  routes
})

export default router

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
